module.exports = __webpack_public_path__ + "media/components/assets/vent_02-67fd9e790592781c68bf0bfc386b5edc.jpg";